import React, { Component } from "react";
// import MainProfile from './MainProfile.jsx';
import InitialMainProfile from "./InitialMainProfile.jsx";
import { withStyles } from "@material-ui/core/styles";
import { compose } from "redux";
import { Button, TextField } from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import LogoutAlert from "../../components/Alert/LogoutAlert.jsx";
import UpdateProfile from "./UpdateProfile.jsx";
import * as actions from '../../actions/index.js';
import { FormattedMessage, injectIntl } from "react-intl";
import { ROLE_CUSTOMER, ROLE_PROVIDER, SERVER_URL } from "../../utils/config/constants.js";
import { withRouter } from "react-router-dom";
import { AccountBalanceWallet, SearchIcon } from "@material-ui/icons";
import { connect } from "react-redux";
import { Clear, Remove, ArrowLeft, ArrowRight, ArrowForward, ArrowBack, Category, Add } from '@material-ui/icons';
import ContentLoader from "react-content-loader";
import NavbarNew from "../../components/NavBarNew/NavbarNew.js";
import Axios from "axios";
import "./index.css"
import ServiceComingSoon from "../Components/ServiceComingSoon.jsx";
import Notaskfound from "../Components/Notaskfound.jsx";
let isMounted = false;


const styles = (theme) => ({
    card: {
        color: theme.palette.secondary.main,
    },
});
const sendProps = (props) => {
    const { classes, ...rest } = props;
    return rest;
};
class TaskListScreenNew extends Component {
    constructor(props) {
        super(props);
        console.log("Task Data", props)
        this.state = {
            update: false,
            showAlert: false,
            serviceDataPrev: this.props.history.location.state.serviceData,
            taskDataPrev: this.props.history.location.state.serviceData,
            // serviceDataPrev: this.props.history.location.state.categoryData.categories
            taskDataByApi: [],
            task: ''
        };
    }
    componentDidMount() {
        console.log('service key', this.state.serviceDataPrev);
        if (this.props.history.location.state.loginPath === "BookingConfirmgback") {
            this.getTaskData(this.props.history.location.state.taskDataFromConfirmPage.key);
        } else {
            this.getTaskData(this.state.serviceDataPrev.key);
        }
    }

    getTaskData = async (key) => {
        // var authToken = getCookies();
        // var latitude = getLatitude();
        // var longitude = getLongitude();
        // console.log('latitude', latitude, 'longitude', longitude, );
        try {
            const { data } = await Axios({
                method: 'get',
                url: `${SERVER_URL}/service/tasklist?category_id=${key}`,
            });
            console.log('tasksssss DATA new', data.data.length);
            if (data.status == 'OK') {
                this.setState({
                    loading: false,
                    //   searchCategoryData: data.data
                    taskDataByApi: data.data,
                    task: data.data.length
                })
            }
            else {
                this.setState({
                    loading: false
                })
            }
        } catch (error) {
            console.log("====================SEARCH ERRORRRRRR", error);
        }
    }

    componentWillUnmount() {
    }

    renderLoading = index => {
        return (
            <div style={{ width: 250, margin: 10, height: 250 }} key={index}>
                <ContentLoader
                    height={200}
                    width={200}
                    speed={2}
                    borderRadius={5}
                    primaryColor="#f3f3f3"
                    secondaryColor="#ecebeb"
                >
                    <rect x="0" y="0" rx="0" ry="0" width="200" height="160" />
                    <rect
                        x="100"
                        y="100"
                        rx="0"
                        ry="0"
                        width="200"
                        height="10"
                    />
                </ContentLoader>
            </div>
        );
    };

    addQty = (item) => {
        const updatedTask = this.state.taskDataByApi.map((task) =>
            task.key === item.key ? { ...task, quantity: task.quantity + 1 } : task
        )
        this.setState({
            taskDataByApi: updatedTask
        })
    };

    lessQty = (item) => {
        const updatedTask = this.state.taskDataByApi.map((task) =>
            task.key === item.key ? { ...task, quantity: task.quantity - (task.quantity > 1 ? 1 : 0) } : task
        )
        this.setState({
            taskDataByApi: updatedTask
        })
    };



    render() {
        var well = {
            boxShadow: "2px 1px 5px #ddd",
            backgroundColor: '#fff',
            padding: 10,
            marginBottom: 20,
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
            // textAlign: 'center',
            cursor: 'pointer',
            borderRadius: 5
        }
        const { userData } = this.props;

        console.log("qqqqqqqqqqqqq", this.state.task);
        return (
            <div className="tz-2-com tz-2-main h4-padding">
                <div style={{ paddingBottom: "25px" }} className="db-list-com">
                    <div className="row">
                        <div className="col-md-12">
                            <NavbarNew
                                title='Choose Task'
                                goback={() => this.props.history.goBack(null)}
                            />
                            <div>
                                {
                                    this.state.task == 0 ? (
                                        <div>
                                            <Notaskfound
                                                text="It doesn't look like tasks are not available for this service. Please email us and let us know what your're looking for."
                                            />
                                        </div>
                                    ) : (
                                        this.state.taskDataByApi.map((task) => (
                                            <div
                                                id="wellStyle"
                                                key={task.key}
                                                style={well}
                                                className="taskclassfortest"
                                            >
                                                <div id="Test4" style={{
                                                    display: 'flex',
                                                    flexDirection: 'row',
                                                    width: '100%',
                                                    justifyContent: 'space-around'
                                                }}>
                                                    <div
                                                        id="task_detail"
                                                        style={{
                                                            display: 'flex',
                                                            flexDirection: 'row'
                                                        }}>
                                                        <div id="serviceImg">
                                                            <img
                                                                id="img_img"
                                                                src={task.image.medium}
                                                                alt={`task-${task.heading}`}
                                                                style={{
                                                                    width: 120,
                                                                    height: 120,
                                                                    borderRadius: 5
                                                                }}
                                                            />
                                                        </div>
                                                        <div id="Test2" style={{
                                                            marginLeft: 20,

                                                            // width: '60%',
                                                            // backgroundColor: 'red'
                                                        }}>
                                                            <p
                                                                id="padding_choose"
                                                                style={{ fontSize: 17, paddingTop: 8, fontWeight: 'bold' }}>
                                                                {task.heading}
                                                                <span style={{}}>
                                                                    {" "}({task.service_type} | {task.booking_type == 'once' ? 'One-Time' : task.booking_type == 'both' ? 'Both' : task.booking_type})
                                                                </span>
                                                            </p>
                                                            <p id="desc" style={{ fontSize: 15, width: 400, marginTop: -10 }}>Description: {task.description}</p>
                                                            <div id="pricedata" style={{
                                                                display: 'flex',
                                                                justifyContent: 'space-between'
                                                            }}>
                                                                <div>
                                                                    <p style={{ fontSize: 15, fontWeight: 'bold', marginTop: 15 }}>Rush-Hour Price - ${task.rush_hr_price}</p>
                                                                    <p style={{ fontSize: 15, fontWeight: 'bold', marginTop: -10 }}>Normal Price - ${task.price}</p>
                                                                </div>
                                                                <div id="Test3"
                                                                    style={{
                                                                        display: 'flex',
                                                                        justifyContent: 'center',
                                                                        alignContent: 'center',
                                                                        alignItems: 'center'
                                                                    }}
                                                                >
                                                                    <div
                                                                        style={{
                                                                            fontSize: 35,
                                                                            display: 'flex',
                                                                            justifyContent: 'center',
                                                                            alignItems: 'flex-end',
                                                                        }}>
                                                                        <span
                                                                            style={{
                                                                                display: 'flex',
                                                                                justifyContent: 'center',
                                                                                alignItems: 'center',
                                                                                color: '#fff',
                                                                                textAlign: 'center',
                                                                                backgroundColor: '#0078ff',
                                                                                padding: '5px',
                                                                                borderRadius: 5
                                                                            }}>
                                                                            <Remove style={{ fontSize: 24, }}
                                                                                onClick={() => this.lessQty(task)}
                                                                            />
                                                                        </span>
                                                                        <p style={{
                                                                            textAlign: 'center',
                                                                            padding: '0px 20px',
                                                                            paddingTop: 20,
                                                                            fontSize: 20,
                                                                            fontWeight: 'bold',
                                                                            marginBottom: 0,
                                                                        }}>{task.quantity}</p>
                                                                        <span
                                                                            style={{
                                                                                display: 'flex',
                                                                                justifyContent: 'center',
                                                                                alignItems: 'center',
                                                                                color: '#fff',
                                                                                textAlign: 'center',
                                                                                backgroundColor: '#0078ff',
                                                                                padding: '5px',
                                                                                borderRadius: 5
                                                                            }}>
                                                                            <Add style={{ fontSize: 24 }}
                                                                                onClick={() => this.addQty(task)}
                                                                            />
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div id="Arrow" style={{
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        justifyContent: 'center',
                                                        alignItems: 'center',
                                                        marginLeft: 20,
                                                        // width: 280,
                                                        // background: 'blue'
                                                    }}>
                                                        <span

                                                            onClick={() => {
                                                                const { serviceDataPrev } = this.state;

                                                                if (this.props.history.location.state.loginPath === "BookingConfirmgback") {
                                                                    this.props.history.push('/user/booking_confirm', {
                                                                        taskData: task,
                                                                        BookingPath: 'taskList',
                                                                        taskDataFututre: serviceDataPrev,
                                                                        booking_data: this.props.history.location.state.booking_data,
                                                                        value: this.props.history.location.state.value,
                                                                        loginPath: this.props.history.location.state.loginPath,
                                                                        BookingPath: this.props.history.location.state.BookingPath,
                                                                        taskDataFromConfirmPage: this.props.history.location.state.taskDataFromConfirmPage
                                                                    });
                                                                } else {
                                                                    this.props.history.push('/user/booking_confirm', {
                                                                        taskData: task,
                                                                        BookingPath: 'taskList',
                                                                        bookingDateEdit: '',
                                                                        bookingSlotEdit: '',
                                                                        taskDataFututre: serviceDataPrev,
                                                                    });
                                                                }
                                                            }
                                                            }
                                                            style={{
                                                            }}>
                                                            <ArrowForward style={{ fontSize: 35, color: '#0078ff', }} className="ArrowForward"/>
                                                        </span>
                                                    </div>
                                                </div>


                                            </div>
                                        )
                                        )
                                    )
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );

    }
}

const mapStateToProps = ({ settings, categories, providers }) => {
    return {
        settings,
        categoryData: categories.categoryData,
        featuredProviderList: providers.featuredProviderList,
        featuredProviderLoader: providers.featuredProviderLoader
    };
};
const composedProfile = compose(connect(mapStateToProps, actions));
export default composedProfile(withRouter(TaskListScreenNew));



// WEBPACK FOOTER //
// ./src/views/User/TaskListScreenNew.jsx